import React from 'react'
import styled from 'styled-components'
import { Swiper, SwiperSlide } from 'swiper/react'

import TrackVisibility from '../../utils/TrackVisibility'
import PlaceholderCard from '../../cards/PlaceholderCard'

const Wrapper = styled.div`
  margin: 0 -14px;
`

const Slide = styled.div`
  padding: 0 14px;
`

const params = {
  slidesPerView: 3,
  slidesPerGroup: 3,
  shouldSwiperUpdate: true,
  speed: 600,
}

type SliderProps<T> = {
  items: T[]
  ItemComponent: React.ComponentType<{ item: T }>
  loading: boolean
  canFetchMore: boolean
  onFetchMore: (...args: any) => any
  getSwiper: React.ComponentProps<typeof Swiper>['onSwiper']
  swiperReady: boolean
  loadingPlaceholder: React.ReactNode
}

const Slider = <T extends Record<'id', string>>({
  getSwiper,
  swiperReady,
  loading,
  canFetchMore,
  onFetchMore,
  items,
  ItemComponent,
  loadingPlaceholder = <PlaceholderCard portrait={false} />,
}: SliderProps<T>) => {
  const suggestionSlides =
    items.map((item) => {
      return {
        key: `slide-${item.id}`,
        Component: (
          <Slide className="swiper-slide" key={item.id}>
            <ItemComponent item={item} />
          </Slide>
        ),
      }
    }) || []

  const loaderSlides =
    canFetchMore || loading
      ? [...Array(4)].map((_, i) => {
          return {
            key: `loader-slide-${i}`,
            Component: (
              // eslint-disable-next-line react/jsx-indent,react/no-array-index-key
              <Slide className="swiper-slide" key={i}>
                {i === 1 ? (
                  <TrackVisibility
                    onChange={(isVisible) => {
                      if (isVisible && !loading) onFetchMore()
                    }}
                  >
                    {loadingPlaceholder}
                  </TrackVisibility>
                ) : (
                  <>{loadingPlaceholder}</>
                )}
              </Slide>
            ),
          }
        })
      : []

  const slides = [...suggestionSlides, ...loaderSlides]

  return (
    <Wrapper>
      <Swiper onSwiper={getSwiper} {...params}>
        {swiperReady &&
          slides.map(({ key, Component }) => (
            <SwiperSlide key={key}>{Component}</SwiperSlide>
          ))}
      </Swiper>
    </Wrapper>
  )
}

export default Slider
